var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "conexao-qrcode-animated-svg",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 576",
        width: "100%",
        height: "100%",
        "aria-hidden": "true"
      }
    },
    [
      _c("defs", [
        _c(
          "filter",
          {
            attrs: {
              id: "conexao-qr-shadow-md",
              x: "-10%",
              y: "-10%",
              width: "120%",
              height: "120%"
            }
          },
          [
            _c("feDropShadow", {
              attrs: {
                dx: "0",
                dy: "4",
                stdDeviation: "6",
                "flood-color": "#000",
                "flood-opacity": "0.1"
              }
            })
          ],
          1
        ),
        _c(
          "filter",
          {
            attrs: {
              id: "conexao-qr-shadow-xl",
              x: "-20%",
              y: "-20%",
              width: "140%",
              height: "140%"
            }
          },
          [
            _c("feDropShadow", {
              attrs: {
                dx: "0",
                dy: "15",
                stdDeviation: "20",
                "flood-color": "#000",
                "flood-opacity": "0.15"
              }
            })
          ],
          1
        ),
        _c("g", { attrs: { id: "conexao-qr-icon-search" } }, [
          _c("path", {
            attrs: {
              d:
                "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z",
              stroke: "#9ca3af",
              "stroke-width": "2",
              fill: "none",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }
          })
        ]),
        _c("g", { attrs: { id: "conexao-qr-icon-dots" } }, [
          _c("circle", {
            staticClass: "fill-primary",
            attrs: { cx: "2", cy: "2", r: "1.8" }
          }),
          _c("circle", {
            staticClass: "fill-primary",
            attrs: { cx: "2", cy: "8", r: "1.8" }
          }),
          _c("circle", {
            staticClass: "fill-primary",
            attrs: { cx: "2", cy: "14", r: "1.8" }
          })
        ]),
        _c("g", { attrs: { id: "conexao-qr-icon-qr" } }, [
          _c("path", {
            attrs: {
              d:
                "M3 3h6v6H3V3zm2 2v2h2V5H5zm8-2h6v6h-6V3zm2 2v2h2V5h-2zM3 13h6v6H3v-6zm2 2v2h2v-2H5zm10-2h4v4h-4v-4zm0 2h2v2h-2v-2z",
              fill: "#374151"
            }
          })
        ]),
        _c("g", { attrs: { id: "conexao-qr-icon-disable" } }, [
          _c("path", {
            attrs: {
              d:
                "M16.01 7L16 3h-2v4h-4V3H8v4.01L3 12l5 4.99V21h2v-4h4v4h2v-4.01L21 12l-4.99-5z",
              fill: "none",
              stroke: "#374151",
              "stroke-width": "1.5"
            }
          }),
          _c("line", {
            attrs: {
              x1: "3",
              y1: "3",
              x2: "21",
              y2: "21",
              stroke: "#374151",
              "stroke-width": "1.8",
              "stroke-linecap": "round"
            }
          })
        ]),
        _c("g", { attrs: { id: "conexao-qr-icon-trash" } }, [
          _c("path", {
            attrs: {
              d:
                "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
              fill: "#374151"
            }
          })
        ]),
        _c("g", { attrs: { id: "conexao-qr-icon-chat-bubble" } }, [
          _c("path", {
            attrs: {
              d:
                "M17 2H7C4.24 2 2 4.23 2 6.98V12.96V13.96C2 16.71 4.24 18.94 7 18.94H8.5C8.77 18.94 9.13 19.12 9.3 19.34L10.8 21.33C11.46 22.21 12.54 22.21 13.2 21.33L14.7 19.34C14.89 19.09 15.19 18.94 15.5 18.94H17C19.76 18.94 22 16.71 22 13.96V6.98C22 4.23 19.76 2 17 2ZM13 13.75H7C6.59 13.75 6.25 13.41 6.25 13C6.25 12.59 6.59 12.25 7 12.25H13C13.41 12.25 13.75 12.59 13.75 13C13.75 13.41 13.41 13.75 13 13.75ZM17 8.75H7C6.59 8.75 6.25 8.41 6.25 8C6.25 7.59 6.59 7.25 7 7.25H17C17.41 7.25 17.75 7.59 17.75 8C17.75 8.41 17.41 8.75 17 8.75Z",
              fill: "#8E8E8E"
            }
          })
        ]),
        _c("g", { attrs: { id: "conexao-qr-icon-contact" } }, [
          _c("path", {
            attrs: {
              d:
                "M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z",
              fill: "#8E8E8E"
            }
          }),
          _c("path", {
            attrs: {
              d:
                "M17.0809 14.1499C14.2909 12.2899 9.74094 12.2899 6.93094 14.1499C5.66094 14.9999 4.96094 16.1499 4.96094 17.3799C4.96094 18.6099 5.66094 19.7499 6.92094 20.5899C8.32094 21.5299 10.1609 21.9999 12.0009 21.9999C13.8409 21.9999 15.6809 21.5299 17.0809 20.5899C18.3409 19.7399 19.0409 18.5999 19.0409 17.3599C19.0309 16.1299 18.3409 14.9899 17.0809 14.1499Z",
              fill: "#8E8E8E"
            }
          })
        ]),
        _c("g", { attrs: { id: "conexao-qr-icon-empty-chat" } }, [
          _c("path", {
            attrs: {
              d:
                "M17 2H7C4.24 2 2 4.23 2 6.98V12.96V13.96C2 16.71 4.24 18.94 7 18.94H8.5C8.77 18.94 9.13 19.12 9.3 19.34L10.8 21.33C11.46 22.21 12.54 22.21 13.2 21.33L14.7 19.34C14.89 19.09 15.19 18.94 15.5 18.94H17C19.76 18.94 22 16.71 22 13.96V6.98C22 4.23 19.76 2 17 2ZM8 12C7.44 12 7 11.55 7 11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11C9 11.55 8.56 12 8 12ZM12 12C11.44 12 11 11.55 11 11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11C13 11.55 12.56 12 12 12ZM16 12C15.44 12 15 11.55 15 11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11C17 11.55 16.56 12 16 12Z",
              fill: "#8E8E8E"
            }
          })
        ]),
        _c("g", { attrs: { id: "conexao-qr-pattern" } }, [
          _c("path", {
            staticClass: "fill-primary",
            attrs: {
              transform: "scale(8.38)",
              d:
                "M0,0 h7v7h-7z M1,1 v5h5v-5z M2,2 h3v3h-3z M14,0 h7v7h-7z M15,1 v5h5v-5z M16,2 h3v3h-3z M0,14 h7v7h-7z M1,15 v5h5v-5z M2,16 h3v3h-3z M8,0 h1v1h-1z M10,0 h2v1h-2z M13,0 h1v2h-1z M8,2 h2v1h-2z M11,2 h1v1h-1z M8,4 h1v2h-1z M10,4 h2v1h-2z M13,4 h1v1h-1z M8,6 h2v1h-2z M11,6 h2v1h-2z M0,8 h1v2h-1z M2,8 h1v1h-1z M4,8 h2v1h-2z M7,8 h1v1h-1z M9,8 h3v2h-3z M13,8 h2v1h-2z M16,8 h1v2h-1z M18,8 h1v1h-1z M20,8 h1v2h-1z M1,10 h2v1h-2z M4,10 h1v2h-1z M6,10 h2v1h-2z M14,10 h1v1h-1z M16,10 h2v1h-2z M19,10 h1v1h-1z M0,12 h2v1h-2z M3,12 h1v1h-1z M5,12 h2v2h-2z M8,12 h1v1h-1z M10,12 h2v1h-2z M13,12 h1v2h-1z M15,12 h2v1h-2z M18,12 h1v2h-1z M20,12 h1v1h-1z M8,14 h2v1h-2z M11,14 h1v2h-1z M14,14 h1v1h-1z M16,14 h2v1h-2z M19,14 h2v1h-2z M8,16 h1v1h-1z M10,16 h2v2h-2z M13,16 h1v1h-1z M15,16 h1v2h-1z M17,16 h1v1h-1z M19,16 h1v2h-1z M8,18 h2v1h-2z M11,18 h1v1h-1z M13,18 h2v1h-2z M16,18 h1v1h-1z M8,20 h1v1h-1z M10,20 h3v1h-3z M14,20 h1v1h-1z M16,20 h2v1h-2z M19,20 h2v1h-2z"
            }
          })
        ])
      ]),
      _c("rect", { attrs: { width: "1024", height: "576", fill: "#ffffff" } }),
      _c("rect", {
        attrs: {
          x: "12",
          y: "12",
          width: "260",
          height: "552",
          rx: "12",
          fill: "#f3f4f6"
        }
      }),
      _c("rect", {
        attrs: {
          x: "284",
          y: "12",
          width: "460",
          height: "552",
          rx: "12",
          fill: "#f3f4f6"
        }
      }),
      _c("rect", {
        attrs: {
          x: "756",
          y: "12",
          width: "256",
          height: "552",
          rx: "12",
          fill: "#f3f4f6"
        }
      }),
      _c("g", { attrs: { transform: "translate(12, 12)" } }, [
        _c("rect", {
          attrs: {
            x: "16",
            y: "20",
            width: "150",
            height: "36",
            rx: "18",
            fill: "#e5e7eb"
          }
        }),
        _c(
          "text",
          { attrs: { x: "34", y: "42", "font-size": "12", fill: "#9ca3af" } },
          [_vm._v(" Buscar conversa... ")]
        ),
        _c("g", { attrs: { transform: "translate(140, 30) scale(0.65)" } }, [
          _c("use", { attrs: { href: "#conexao-qr-icon-search" } })
        ]),
        _c("circle", {
          staticClass: "fill-primary",
          attrs: { cx: "188", cy: "38", r: "14" }
        }),
        _c("path", {
          attrs: {
            d: "M183 38 h10 M188 33 v10",
            stroke: "#ffffff",
            "stroke-width": "1.8",
            "stroke-linecap": "round"
          }
        }),
        _c("use", {
          attrs: { href: "#conexao-qr-icon-dots", x: "224", y: "31" }
        }),
        _c("g", { attrs: { transform: "translate(16, 74)" } }, [
          _c("rect", {
            staticClass: "fill-primary",
            attrs: { x: "0", y: "0", width: "64", height: "28", rx: "14" }
          }),
          _c(
            "text",
            {
              attrs: {
                x: "32",
                y: "18",
                "font-size": "12",
                "font-weight": "500",
                fill: "#ffffff",
                "text-anchor": "middle"
              }
            },
            [_vm._v(" Todas ")]
          ),
          _c(
            "text",
            {
              attrs: {
                x: "90",
                y: "18",
                "font-size": "12",
                "font-weight": "500",
                fill: "#374151"
              }
            },
            [_vm._v(" Conversas ")]
          ),
          _c(
            "text",
            {
              attrs: {
                x: "160",
                y: "18",
                "font-size": "12",
                "font-weight": "500",
                fill: "#374151"
              }
            },
            [_vm._v(" Grupos ")]
          )
        ]),
        _c("g", { attrs: { transform: "translate(114, 278)" } }, [
          _c("use", { attrs: { href: "#conexao-qr-icon-empty-chat" } }),
          _c(
            "text",
            {
              attrs: {
                x: "12",
                y: "48",
                "font-size": "11",
                fill: "#9ca3af",
                "text-anchor": "middle"
              }
            },
            [_vm._v(" Nenhuma conversa encontrada ")]
          )
        ])
      ]),
      _c("g", { attrs: { transform: "translate(514, 240)" } }, [
        _c("g", { attrs: { transform: "translate(-12, 0)" } }, [
          _c("use", { attrs: { href: "#conexao-qr-icon-chat-bubble" } })
        ]),
        _c(
          "text",
          {
            attrs: {
              x: "0",
              y: "60",
              "font-size": "16",
              "font-weight": "500",
              fill: "#374151",
              "text-anchor": "middle"
            }
          },
          [_vm._v(" Selecione ou inicie uma conversa ")]
        ),
        _c(
          "text",
          {
            attrs: {
              x: "0",
              y: "84",
              "font-size": "11",
              fill: "#6b7280",
              "text-anchor": "middle"
            }
          },
          [
            _c("tspan", [
              _vm._v("Escolha uma das conversas ao lado, ou toque em")
            ]),
            _c("tspan", { attrs: { "font-weight": "600", fill: "#374151" } }, [
              _vm._v('"Nova Conversa"')
            ]),
            _c("tspan", [_vm._v("no topo da")])
          ]
        ),
        _c(
          "text",
          {
            attrs: {
              x: "0",
              y: "100",
              "font-size": "11",
              fill: "#6b7280",
              "text-anchor": "middle"
            }
          },
          [_vm._v(" lista para começar uma conversa com qualquer número. ")]
        ),
        _c("rect", {
          staticClass: "fill-primary",
          attrs: { x: "-80", y: "118", width: "160", height: "40", rx: "20" }
        }),
        _c(
          "text",
          {
            attrs: {
              x: "0",
              y: "143",
              "font-size": "13",
              "font-weight": "500",
              fill: "#ffffff",
              "text-anchor": "middle"
            }
          },
          [_vm._v(" + Nova Conversa ")]
        ),
        _c(
          "text",
          {
            attrs: {
              x: "0",
              y: "188",
              "font-size": "10",
              fill: "#9ca3af",
              "text-anchor": "middle"
            }
          },
          [
            _vm._v(
              " Abra o menu ⋮ acima e escaneie o QR Code para conectar seu WhatsApp. "
            )
          ]
        )
      ]),
      _c("g", { attrs: { transform: "translate(884, 240)" } }, [
        _c("g", { attrs: { transform: "translate(-12, 0)" } }, [
          _c("use", { attrs: { href: "#conexao-qr-icon-contact" } })
        ]),
        _c(
          "text",
          {
            attrs: {
              x: "0",
              y: "56",
              "font-size": "11",
              fill: "#9ca3af",
              "text-anchor": "middle"
            }
          },
          [_vm._v(" Selecione uma conversa para ver os detalhes do ")]
        ),
        _c(
          "text",
          {
            attrs: {
              x: "0",
              y: "72",
              "font-size": "11",
              fill: "#9ca3af",
              "text-anchor": "middle"
            }
          },
          [_vm._v(" contato ")]
        )
      ]),
      _c("g", { attrs: { transform: "translate(260, 62)" } }, [
        _c("g", { staticClass: "dropdown" }, [
          _c("rect", {
            attrs: {
              x: "0",
              y: "0",
              width: "200",
              height: "144",
              rx: "10",
              fill: "#ffffff",
              filter: "url(#conexao-qr-shadow-md)"
            }
          }),
          _c("circle", {
            attrs: { cx: "18", cy: "22", r: "4", fill: "#eab308" }
          }),
          _c(
            "text",
            {
              attrs: {
                x: "30",
                y: "26",
                "font-size": "11",
                "font-weight": "600",
                fill: "#eab308"
              }
            },
            [_vm._v(" Conectando ")]
          ),
          _c("rect", {
            attrs: {
              x: "0",
              y: "38",
              width: "200",
              height: "1",
              fill: "#e5e7eb"
            }
          }),
          _c("rect", {
            staticClass: "menu-hover",
            attrs: { x: "6", y: "44", width: "188", height: "30", rx: "6" }
          }),
          _c("g", { attrs: { transform: "translate(14, 50) scale(0.7)" } }, [
            _c("use", { attrs: { href: "#conexao-qr-icon-qr" } })
          ]),
          _c(
            "text",
            { attrs: { x: "40", y: "63", "font-size": "11", fill: "#374151" } },
            [_vm._v(" Conectar via QR Code ")]
          ),
          _c("g", { attrs: { transform: "translate(14, 82) scale(0.7)" } }, [
            _c("use", { attrs: { href: "#conexao-qr-icon-disable" } })
          ]),
          _c(
            "text",
            { attrs: { x: "40", y: "95", "font-size": "11", fill: "#374151" } },
            [_vm._v(" Desativar conexão ")]
          ),
          _c("g", { attrs: { transform: "translate(14, 114) scale(0.7)" } }, [
            _c("use", { attrs: { href: "#conexao-qr-icon-trash" } })
          ]),
          _c(
            "text",
            {
              attrs: { x: "40", y: "127", "font-size": "11", fill: "#374151" }
            },
            [_vm._v(" Remover permanentemente ")]
          )
        ])
      ]),
      _c("g", { staticClass: "modal-overlay" }, [
        _c("rect", {
          attrs: { width: "1024", height: "576", fill: "rgba(0,0,0,0.4)" }
        }),
        _c("rect", {
          attrs: {
            x: "332",
            y: "60",
            width: "360",
            height: "456",
            rx: "14",
            fill: "#ffffff",
            filter: "url(#conexao-qr-shadow-xl)"
          }
        }),
        _c(
          "text",
          {
            attrs: {
              x: "512",
              y: "100",
              "font-size": "15",
              "font-weight": "500",
              fill: "#374151",
              "text-anchor": "middle"
            }
          },
          [_vm._v(" Conectar WhatsApp ")]
        ),
        _c("g", { attrs: { transform: "translate(660, 85)" } }, [
          _c("path", {
            attrs: {
              d: "M0 0 l12 12 M12 0 l-12 12",
              stroke: "#6b7280",
              "stroke-width": "1.8",
              "stroke-linecap": "round"
            }
          })
        ]),
        _c("rect", {
          attrs: {
            x: "332",
            y: "120",
            width: "360",
            height: "1",
            fill: "#e5e7eb"
          }
        }),
        _c(
          "text",
          {
            attrs: {
              x: "512",
              y: "148",
              "font-size": "11",
              fill: "#6b7280",
              "text-anchor": "middle"
            }
          },
          [
            _c("tspan", [_vm._v("Abra o WhatsApp no seu celular, vá em")]),
            _c("tspan", { attrs: { "font-weight": "600", fill: "#374151" } }, [
              _vm._v("Configurações >")
            ])
          ]
        ),
        _c(
          "text",
          {
            attrs: {
              x: "512",
              y: "165",
              "font-size": "11",
              fill: "#6b7280",
              "text-anchor": "middle"
            }
          },
          [
            _c("tspan", { attrs: { "font-weight": "600", fill: "#374151" } }, [
              _vm._v(" Aparelhos conectados > Conectar um aparelho ")
            ]),
            _c("tspan", [_vm._v("e escaneie o")])
          ]
        ),
        _c(
          "text",
          {
            attrs: {
              x: "512",
              y: "182",
              "font-size": "11",
              fill: "#6b7280",
              "text-anchor": "middle"
            }
          },
          [_vm._v(" QR Code abaixo. ")]
        ),
        _c("g", { staticClass: "qr-code" }, [
          _c("rect", {
            attrs: {
              x: "412",
              y: "220",
              width: "200",
              height: "200",
              rx: "6",
              fill: "#ffffff",
              stroke: "#e5e7eb",
              "stroke-width": "1"
            }
          }),
          _c("g", { attrs: { transform: "translate(424, 232)" } }, [
            _c("use", { attrs: { href: "#conexao-qr-pattern" } })
          ])
        ]),
        _c("rect", {
          attrs: {
            x: "332",
            y: "450",
            width: "360",
            height: "1",
            fill: "#e5e7eb"
          }
        }),
        _c(
          "text",
          {
            attrs: {
              x: "512",
              y: "488",
              "font-size": "13",
              "font-weight": "500",
              fill: "#374151",
              "text-anchor": "middle"
            }
          },
          [_vm._v(" Cancelar ")]
        ),
        _c("line", {
          attrs: {
            x1: "498",
            y1: "494",
            x2: "526",
            y2: "494",
            stroke: "#374151",
            "stroke-width": "1"
          }
        })
      ]),
      _c("g", { staticClass: "cursor" }, [
        _c("circle", {
          staticClass: "cursor-ring stroke-primary",
          attrs: { cx: "4", cy: "4", r: "6", fill: "none", "stroke-width": "2" }
        }),
        _c("path", {
          attrs: {
            d: "M0 0 L0 16 L4 12 L7 18 L9 17 L6 11 L11 11 Z",
            fill: "#1f2937",
            stroke: "#1f2937",
            "stroke-width": "1",
            "stroke-linejoin": "round"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }